import { render, staticRenderFns } from "./InjuryIndex.vue?vue&type=template&id=122f7bc8&scoped=true&"
import script from "./InjuryIndex.vue?vue&type=script&lang=js&"
export * from "./InjuryIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "122f7bc8",
  null
  
)

export default component.exports